import axios from "axios";
import { base_url, getToken } from '../../config/config';

const token = getToken();
const headers = {
  "Content-Type": "application/json",
  "authorization": `Bearer ${token}`,
}

export const getAllCustomForms = async () => {
  const response = await axios.get(`${base_url}/v1/getAllCustomForms`, { headers });
  return response.data;
};

export const getCustomFormById = async (id) => {
  const response = await axios.get(`${base_url}/v1/getCustomFormById`, {
    headers,
    params: { id }
  });
  return response.data;
};